import { useEffect } from 'react';

import type { GTMConfig } from '@/lib/gtm';
import { gtm } from '@/lib/gtm';

export function useAnalytics(config: GTMConfig) {
  useEffect(() => {
    gtm.initialize(config);
  }, [config]);
}
